import * as utils from './utils';
import * as yup from 'yup';
import { Fournisseur } from '../entities';

export const schemaFournisseur = yup.object<Partial<Fournisseur>>({
    name: yup.string().required('Ce champ est requis'),
    created_at: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
    fk_id_contact_gestionnaire: yup.number().nullable(),
    fk_id_contact_par_defaut: yup.number().nullable(),
    fk_id_lieu: yup.number().nullable(),
    notes: yup.string().nullable(),
    pct_commission_defaut: yup.number().nullable().transform(utils.emptyStringToNullTransform),
    b_entente: yup.boolean().default(false).transform(utils.nullBoolToFalse),
    trigger_suivi: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
    debut_relation_date: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
    fk_methode_paiement: yup.number().nullable(),
    delais_reception_facture: yup
        .number()
        .nullable()
        .transform(utils.emptyStringToNullTransform)
        .moreThan(0, 'Doit être supérieur à 0'),
    delais_reception_facture_texte: yup.string().nullable(),
    fk_status_entreprise: yup.number().nullable(),
    nom_acces_d: yup.string().nullable(),
    neq: yup.string().nullable(),
    tps: yup.string().nullable(),
    tvq: yup.string().nullable(),
    actif: yup.boolean().default(true).transform(utils.nullBoolToFalse),
}) as yup.ObjectSchema<Partial<Fournisseur>>;
